export class OperatorHelpers {

  static mapToList(source: { [key: string]: any }, target: any[]): any[] {
    if (source) {
      for (const key in source) {
        if (source.hasOwnProperty(key)) {
          target.push({ ...source[key], id: key } as any);
        }
      }
    }

    return target;
  }
}

